import { makeRootStyles } from "../../../theme/styles";

const useStyles = makeRootStyles(
  {
    "@keyframes spinAnimation": {
      "0%": {
        transform: "rotate(0deg)",
      },
      "100%": {
        transform: "rotate(360deg)",
      },
    },
    spinner: {
      animationDuration: "1s",
      animationName: "$spinAnimation",
      animationIterationCount: "infinite",
      animationTimingFunction: "linear",
    },
  },
  {
    name: "N0Spinner",
  },
);

export { useStyles };
